(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auto-image-carousel"] && !Shopify.designMode) return;
  try {
    
  // Alpine.js + Embla Carousel 初期化
  document.addEventListener('alpine:init', () => {
    Alpine.data('emblaSlider', (options = {}) => ({
      embla: null,
      autoplay: options.autoplay ?? true,
      loop: options.loop ?? true,
      fade: options.fade ?? false,
      init() {
        this.embla = EmblaCarousel(this.$refs.emblaViewport, {
          loop: this.loop,
          align: 'start',
          containScroll: 'trimSnaps',
        });

        // 自動スクロール設定
        if (this.autoplay) {
          const autoplay = () => {
            if (!this.embla.canScrollNext()) {
              this.embla.scrollTo(0);
            } else {
              this.embla.scrollNext();
            }
          };
          setInterval(autoplay, 3500);
        }
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-collab-carousel"] && !Shopify.designMode) return;
  try {
    
  class JpCollabCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.viewport = this.querySelector('[data-carousel-viewport]');
      if (!this.viewport) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.firstSlide = this.querySelector('[data-carousel-slide]');
      this.previous = this.querySelector('[data-carousel-previous]');
      this.next = this.querySelector('[data-carousel-next]');
      this.pause = this.querySelector('[data-carousel-pause]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.interacting = false;
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.pause?.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      this.viewport.addEventListener('pointerdown', () => { this.interacting = true; this.schedule(); }, options);
      const release = () => { if (this.interacting) { this.interacting = false; this.schedule(); } };
      document.addEventListener('pointerup', release, options);
      document.addEventListener('pointercancel', release, options);
      this.viewport.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.scrollTo(event.key === 'Home' ? 0 : this.maximum(), true);
          this.schedule();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.resizeObserver = new ResizeObserver(() => { this.updateControls(); this.schedule(); });
      this.resizeObserver.observe(this.viewport);
      this.updateControls();
      this.schedule();
    }
    maximum() {
      return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    }
    scrollTo(left, jump = false) {
      this.viewport.scrollTo({ left, behavior: jump || this.motion.matches ? 'instant' : 'smooth' });
    }
    move(direction) {
      const maximum = this.maximum();
      if (!maximum || !this.firstSlide) return;
      const position = this.viewport.scrollLeft;
      const step = this.firstSlide.getBoundingClientRect().width;
      let target = Math.max(0, Math.min(maximum, position + direction * step));
      let wrap = false;
      if (this.dataset.loop === 'true') {
        if (direction > 0 && position >= maximum - 1) { target = 0; wrap = true; }
        if (direction < 0 && position <= 1) { target = maximum; wrap = true; }
      }
      this.scrollTo(target, wrap);
      this.schedule();
    }
    updateControls() {
      const maximum = this.maximum();
      const loop = this.dataset.loop === 'true';
      if (this.previous) this.previous.disabled = maximum <= 1 || (!loop && this.viewport.scrollLeft <= 1);
      if (this.next) this.next.disabled = maximum <= 1 || (!loop && this.viewport.scrollLeft >= maximum - 1);
    }
    schedule() {
      clearTimeout(this.timer);
      const reduced = this.motion.matches;
      if (this.pause) {
        this.pause.disabled = reduced || this.maximum() <= 1;
        this.pause.setAttribute('aria-label', this.paused || reduced ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel);
        this.pause.setAttribute('aria-pressed', String(this.paused));
        this.pause.firstElementChild.textContent = this.paused || reduced ? '▶' : 'Ⅱ';
      }
      if (this.dataset.autoplay !== 'true' || this.maximum() <= 1 || this.paused || reduced || this.hovered || this.focused || this.interacting || document.hidden) return;
      if (this.dataset.loop !== 'true' && this.viewport.scrollLeft >= this.maximum() - 1) return;
      this.timer = setTimeout(() => this.move(1), 3500);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
  }
  if (!customElements.get('jp-collab-carousel')) customElements.define('jp-collab-carousel', JpCollabCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-home-slideshow"]) return;
  try {
    
  class JpHomeSlideshow extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-home-slide]')];
      this.bars = [...this.querySelectorAll('[data-home-index]')];
      this.pauseButton = this.querySelector('[data-home-pause]');
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('[data-home-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelector('[data-home-previous]')?.addEventListener('click', () => this.show(this.index - 1), options);
      this.bars.forEach((bar) => bar.addEventListener('click', () => this.show(Number(bar.dataset.homeIndex)), options));
      this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, options);
      this.addEventListener('pointerdown', (event) => { if (event.button === 0) this.startX = event.clientX; this.swiped = false; }, options);
      this.addEventListener('pointercancel', () => { this.startX = undefined; }, options);
      this.addEventListener('pointerup', (event) => {
        const distance = event.clientX - this.startX;
        if (Number.isFinite(distance) && Math.abs(distance) > 50) { this.swiped = true; this.show(this.index + (distance < 0 ? 1 : -1)); }
        this.startX = undefined;
      }, options);
      this.addEventListener('click', (event) => { if (this.swiped) { event.preventDefault(); this.swiped = false; } }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      this.bars.forEach((bar, i) => { if (i === this.index) bar.setAttribute('aria-current', 'true'); else bar.removeAttribute('aria-current'); });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const stopped = this.paused || this.motion.matches;
      if (this.pauseButton) {
        this.pauseButton.disabled = this.motion.matches;
        this.pauseButton.setAttribute('aria-label', stopped ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.firstElementChild.textContent = stopped ? '▶' : 'Ⅱ';
      }
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || stopped || this.hovered || this.focused || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Math.max(1000, Number(this.dataset.speed) || 5000));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  }
  if (!customElements.get('jp-home-slideshow')) customElements.define('jp-home-slideshow', JpHomeSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-imersian-inhome"] && !Shopify.designMode) return;
  try {
    
  class JpImersianInhome extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.imersian-variant-sku');
      this.buttons = [...this.querySelectorAll('button')];
      this.controller = new AbortController();
      this.observer = new MutationObserver(() => this.syncVisibility());
      for (const button of this.buttons) this.observer.observe(button, { attributes: true, attributeFilter: ['style'] });
      document.addEventListener('variant:update', (event) => this.updateVariant(event), { signal: this.controller.signal });
      this.syncVisibility();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
    syncVisibility() {
      if (window.Shopify?.designMode || this.dataset.autoHide !== 'true') return;
      this.hidden = this.buttons.every(button => button.style.display === 'none');
    }
    updateVariant(event) {
      if (!this.dataset.productId || String(event.detail?.data?.productId) !== this.dataset.productId) return;
      this.input.value = event.detail.resource?.id || '';
      this.input.setAttribute('value', this.input.value);
      for (const button of this.buttons) button.style.display = 'none';
      this.syncVisibility();
      if (!this.input.value) return;
      window.jpImersianReady?.then(client => {
        if (this.isConnected && this.input.value) return client.handleVariantChange?.();
      }).catch(() => {});
    }
  }
  if (!customElements.get('jp-imersian-inhome')) customElements.define('jp-imersian-inhome', JpImersianInhome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-product-reviews"]) return;
  try {
    
  class JPProductReviews extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { capture: true, signal: this.listeners.signal };
      document.addEventListener('click', this.activate, options);
      document.addEventListener('keydown', this.activate, options);
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    activate = (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('.product-details .jdgm-preview-badge')) return;
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      if (!this.querySelector('#judgeme_product_reviews')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.scrollIntoView({ block: 'start', behavior: 'instant' });
      this.focus({ preventScroll: true });
    };
  }

  if (!customElements.get('jp-product-reviews')) {
    customElements.define('jp-product-reviews', JPProductReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-rooms-scene"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const markers = () => document.querySelectorAll('.jp-rooms [data-styling-marker].is-active');
    const fit = (marker) => {
      const card = marker.querySelector('[data-styling-card]');
      const area = marker.closest('.jp-rooms__hotspot-area');
      if (!card || !area) return;
      card.style.setProperty('--jp-card-shift', '0px');
      const bounds = area.getBoundingClientRect();
      const rect = card.getBoundingClientRect();
      const shift = Math.max(bounds.left + 8 - rect.left, Math.min(0, bounds.right - 8 - rect.right));
      card.style.setProperty('--jp-card-shift', `${shift}px`);
    };
    const close = (marker) => {
      const card = marker.querySelector('[data-styling-card]');
      if (card?.contains(document.activeElement)) marker.querySelector('[data-styling-pin]')?.focus();
      marker.classList.remove('is-active');
      marker.querySelector('[data-styling-pin]')?.setAttribute('aria-expanded', 'false');
    };
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const pin = event.target.closest('.jp-rooms [data-styling-pin]');
      if (event.target.closest('.jp-rooms [data-styling-card]')) return;
      for (const marker of markers()) {
        if (!pin || !marker.contains(pin)) close(marker);
      }
      if (pin) {
        const marker = pin.closest('[data-styling-marker]');
        const open = !marker.classList.contains('is-active');
        marker.classList.toggle('is-active', open);
        pin.setAttribute('aria-expanded', String(open));
        if (open) fit(marker);
      }
    });
    window.addEventListener('resize', () => { for (const marker of markers()) fit(marker); });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      for (const marker of markers()) close(marker);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  let jpCartReloadPending = false;
  document.addEventListener('cart:update', (event) => {
    if (jpCartReloadPending || event.detail?.data?.source !== 'cart-items-component') return;
    const cart = event.target?.closest?.('cart-items-component:not([data-drawer])');
    if (!cart?.querySelector('.cart-page__more-blocks .shopify-app-block')) return;
    jpCartReloadPending = true;
    queueMicrotask(() => window.location.reload());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.gl-filters-toggle');
    if (!button) return;

    const wrapper = button.closest('.collection-wrapper--gl-filters');
    if (!wrapper) return;

    const isOpen = wrapper.classList.toggle('gl-filters-open');
    button.setAttribute('aria-expanded', String(isOpen));
    button.querySelector('.gl-filters-toggle__symbol').textContent = isOpen ? '−' : '+';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  const productCache = new Map();
  const STORAGE_KEY_HANDLES = 'viewedProductHandles';
  
  function getStoredHandles() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY_HANDLES) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  
  class RecentlyViewedProductsSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      const run = () => this.loadProducts();
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: 500 });
      } else {
        window.setTimeout(run, 0);
      }
    }
  
    async loadProducts() {
      const currentHandle = this.dataset.currentHandle || '';
      const sectionLimit = Number.parseInt(this.dataset.maxProducts || '4', 10) || 4;
      const currency = this.dataset.currency || 'USD';
  
      const viewedHandles = getStoredHandles()
        .filter((handle) => typeof handle === 'string' && handle.length > 0)
        .filter((handle) => handle !== currentHandle)
        .slice(0, sectionLimit);
  
      if (viewedHandles.length === 0) {
        this.hidden = true;
        return;
      }
  
      const products = await this.fetchProducts(viewedHandles);
      const validProducts = products.filter(Boolean).slice(0, sectionLimit);
  
      if (validProducts.length === 0) {
        this.hidden = true;
        return;
      }
  
      const grid = this.querySelector('[ref="recentlyViewedGrid"]');
      if (!(grid instanceof HTMLElement)) {
        this.hidden = true;
        return;
      }
  
      grid.innerHTML = '';
      validProducts.forEach((product) => {
        grid.append(this.renderCard(product, currency));
      });
  
      this.hidden = false;
    }
  
    async fetchProducts(handles) {
      const root = window.Shopify?.routes?.root || '/';
      const previewParams = new URLSearchParams(window.location.search);
  
      const requests = handles.map(async (handle) => {
        if (productCache.has(handle)) return productCache.get(handle);
  
        const url = new URL(`${root}products/${encodeURIComponent(handle)}`, window.location.origin);
        url.searchParams.set('view', 'recently-viewed');
        previewParams.forEach((value, key) => {
          if (!url.searchParams.has(key)) {
            url.searchParams.set(key, value);
          }
        });
  
        try {
          const response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) return null;
          const data = await response.json();
          productCache.set(handle, data);
          return data;
        } catch {
          return null;
        }
      });
  
      return Promise.all(requests);
    }
  
    renderCard(product, currency) {
      const item = document.createElement('li');
      item.className = 'recently-viewed-products__item';
  
      const link = document.createElement('a');
      link.className = 'recently-viewed-products__card-link';
      link.href = product.url || `/products/${product.handle}`;
  
      const imageWrap = document.createElement('div');
      imageWrap.className = 'recently-viewed-products__image-wrap';
  
      if (Array.isArray(product.images) && product.images[0]) {
        const img = document.createElement('img');
        img.className = 'recently-viewed-products__image';
        img.src = product.images[0];
        img.alt = product.title || '';
        img.loading = 'lazy';
        imageWrap.append(img);
      }
  
      const name = document.createElement('p');
      name.className = 'recently-viewed-products__name';
      name.textContent = product.title || '';
  
      const price = document.createElement('div');
      price.className = 'recently-viewed-products__price';
      if (product.price_html) {
        price.innerHTML = product.price_html;
      } else {
        price.textContent = this.formatMoney(product.price, currency);
      }
  
      link.append(imageWrap, name, price);
      item.append(link);
  
      return item;
    }
  
    formatMoney(cents, currency) {
      const value = Number(cents || 0) / 100;
  
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        }).format(value);
      } catch {
        return `$${value.toFixed(2)}`;
      }
    }
  }
  
  if (!customElements.get('recently-viewed-products-section')) {
    customElements.define('recently-viewed-products-section', RecentlyViewedProductsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
